export default "__VITE_ASSET__97e32f54__"